import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ onOpenConsultation }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Products', path: '/products' },
    { name: 'Industries', path: '/industries' },
    { name: 'Tech Stack', path: '/technologies' },
    { name: 'About', path: '/about' },
    { name: 'Team', path: '/team' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      style={{
        position: 'fixed',
        top: '8px',
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '0 14px',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      {/* Sleek Floating Pill Glass Container */}
      <div
        className="glass-card header-pill-container"
        style={{
          width: 'auto',
          padding: '4px 8px 4px 14px',
          borderRadius: '9999px',
          background: scrolled ? 'rgba(6, 8, 22, 0.95)' : 'rgba(15, 23, 42, 0.88)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: scrolled ? '1px solid rgba(108, 99, 255, 0.4)' : '1px solid rgba(255, 255, 255, 0.12)',
          boxShadow: scrolled ? '0 10px 30px rgba(0, 0, 0, 0.7), 0 0 20px rgba(108, 99, 255, 0.25)' : '0 6px 20px rgba(0, 0, 0, 0.35)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          pointerEvents: 'auto',
          transition: 'all 0.3s ease',
        }}
      >
        {/* Mobile Brand Logo (Left Side on Phone/Tablet) */}
        <Link
          to="/"
          className="mobile-brand-logo"
          style={{
            display: 'none',
            alignItems: 'center',
            gap: '8px',
            textDecoration: 'none',
            paddingLeft: '4px',
          }}
        >
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '8px',
              background: '#FFFFFF',
              border: '1.5px solid #D6A236',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '2px',
              boxShadow: '0 0 10px rgba(214, 162, 54, 0.4)',
              flexShrink: 0,
              overflow: 'hidden',
            }}
          >
            <img
              src="/assets/images/hungry-logo.svg"
              alt="Hungry Top Logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: 'scale(1.8)',
              }}
            />
          </div>
          <span
            style={{
              color: '#FFFFFF',
              fontWeight: 800,
              fontSize: '0.88rem',
              letterSpacing: '-0.02em',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}
          >
            HUNGRY TOP
          </span>
        </Link>

        {/* Center Desktop Navigation Links */}
        <nav
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
          }}
          className="desktop-nav-pill"
        >
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;

            return (
              <Link
                key={link.name}
                to={link.path}
                style={{
                  padding: '5px 12px',
                  borderRadius: '9999px',
                  color: isActive ? '#00D4FF' : '#A3A8B8',
                  background: isActive ? 'rgba(0, 212, 255, 0.15)' : 'transparent',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  border: isActive ? '1px solid rgba(0, 212, 255, 0.25)' : '1px solid transparent',
                  whiteSpace: 'nowrap',
                }}
              >
                {link.name}
              </Link>
            );
          })}
        </nav>

        {/* Right CTA Actions / Mobile 3-Bar Button */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Desktop App Link */}
          <a
            href="https://play.google.com/store/apps/details?id=com.hungrytop"
            target="_blank"
            rel="noopener noreferrer"
            title="Download HungryTop App on Google Play"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              padding: '5px 10px',
              borderRadius: '9999px',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              color: '#FFFFFF',
              fontSize: '0.75rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              whiteSpace: 'nowrap',
            }}
            className="desktop-header-action"
          >
            <i className="fab fa-google-play" style={{ color: '#00D4FF', fontSize: '0.8rem' }}></i>
            <span>App</span>
          </a>

          {/* Desktop Book Consultation Button */}
          <button
            onClick={onOpenConsultation}
            className="btn-primary-gradient desktop-header-action"
            style={{ padding: '5px 14px', fontSize: '0.78rem', borderRadius: '9999px', minHeight: '32px' }}
          >
            <span>Book Consultation</span>
            <i className="fas fa-arrow-right" style={{ fontSize: '0.7rem' }}></i>
          </button>

          {/* Mobile 3-Bar Touch Button (Positioned Top Right) */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle Mobile Menu"
            style={{
              display: 'none',
              background: 'rgba(108, 99, 255, 0.18)',
              border: '1px solid rgba(108, 99, 255, 0.45)',
              color: '#FFFFFF',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.05rem',
              boxShadow: '0 0 14px rgba(108, 99, 255, 0.35)',
            }}
            className="mobile-hamburger-btn"
          >
            <i className={mobileMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
          </button>
        </div>
      </div>

      {/* Responsive Styles Injection */}
      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav-pill {
            display: none !important;
          }
          .desktop-header-action {
            display: none !important;
          }
          .mobile-brand-logo {
            display: flex !important;
          }
          .mobile-hamburger-btn {
            display: flex !important;
          }
          .header-pill-container {
            width: 100% !important;
            justify-content: space-between !important;
            padding: 6px 14px !important;
            border-radius: 9999px !important;
          }
        }
      `}</style>

      {/* Full-Screen Native App Mobile Menu Drawer */}
      {mobileMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: '64px',
            left: '14px',
            right: '14px',
            background: 'rgba(6, 8, 22, 0.96)',
            backdropFilter: 'blur(28px)',
            WebkitBackdropFilter: 'blur(28px)',
            borderRadius: '24px',
            border: '1px solid rgba(108, 99, 255, 0.4)',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            boxShadow: '0 25px 60px rgba(0, 0, 0, 0.95)',
            pointerEvents: 'auto',
            maxHeight: 'calc(100vh - 80px)',
            overflowY: 'auto',
          }}
        >
          {/* Mobile Logo Brand Title in Drawer */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: '10px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <img
              src="/assets/images/hungry-logo.svg"
              alt="Hungry Top Logo"
              style={{ width: '32px', height: '32px' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ color: '#FFF', fontWeight: 800, fontSize: '0.95rem' }}>HUNGRY TOP</span>
              <span style={{ color: '#00D4FF', fontSize: '0.55rem', letterSpacing: '0.14em' }}>TECHNOLOGIES</span>
            </div>
          </div>

          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                color: location.pathname === link.path ? '#00D4FF' : '#FFFFFF',
                fontSize: '1rem',
                fontWeight: 700,
                textDecoration: 'none',
                padding: '10px 16px',
                borderRadius: '14px',
                background: location.pathname === link.path ? 'rgba(0, 212, 255, 0.15)' : 'rgba(255, 255, 255, 0.04)',
                border: location.pathname === link.path ? '1px solid rgba(0, 212, 255, 0.3)' : '1px solid transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minHeight: '44px',
              }}
            >
              <span>{link.name}</span>
              <i className="fas fa-chevron-right" style={{ fontSize: '0.75rem', opacity: 0.6 }}></i>
            </Link>
          ))}

          <button
            onClick={() => {
              setMobileMenuOpen(false);
              if (onOpenConsultation) onOpenConsultation();
            }}
            className="btn-primary-gradient"
            style={{ width: '100%', marginTop: '8px', minHeight: '46px', fontSize: '0.95rem' }}
          >
            <span>Book Consultation</span>
            <i className="fas fa-arrow-right"></i>
          </button>

          <a
            href="https://play.google.com/store/apps/details?id=com.hungrytop"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary-glass"
            style={{ width: '100%', textDecoration: 'none', minHeight: '44px', display: 'flex', gap: '10px', justifyContent: 'center' }}
          >
            <i className="fab fa-google-play" style={{ color: '#00D4FF' }}></i>
            <span>Download HungryTop App</span>
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
